export function getLastPathSegment (pathStr) {
    pathStr = pathStr.toLowerCase();
    const split = pathStr.split('/');

    return split.pop();
}

export function getSubIdFromUrlPath () {
    return extractSubIdFromPath(window.location.pathname);
}

export function extractSubIdFromPath (path) {
    // match :subId value when URL path is `/s/:subId/../../`
    const subIdPathMatch = path.match(/^\/s\/([^/]+)\//);

    return subIdPathMatch ? subIdPathMatch[1] : null;
}
